import { Link as RouterLink } from 'react-router-dom';
import { styled } from 'theme';

const Link = styled(RouterLink, {
  // Reset
  boxSizing: 'border-box',
  flexShrink: 0,
  outline: 'none',
  textDecoration: 'none',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  '&:disabled': {
    pointerEvents: 'none',
  },
  '&::before': {
    boxSizing: 'border-box',
  },
  '&::after': {
    boxSizing: 'border-box',
  },

  // Custom
  color: '$secondary',
  borderBottom: '1px solid transparent',
  lineHeight: 'inherit',
  transition: 'all 200ms linear',
  '&:hover': {
    borderColor: 'currentColor',
  },
  '&:focus': {
    boxShadow: '$focus',
  },

  variants: {
    variant: {
      unstyled: {
        color: 'inherit',
        border: '0',
      },
    },
  },
});

export default Link;
